import { useContext, useEffect, useState } from 'react';

import {
	DeleteOutlined,
	EyeOutlined,
	OrderedListOutlined,
	PauseCircleOutlined,
	PlayCircleOutlined,
	UnorderedListOutlined,
} from '@ant-design/icons';
import { Button, Flex, List, Popconfirm, Table, Tooltip, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useDeleteMonitorCategory } from '@/api/monitor_collections';
import { PageContext } from '@/providers/PageContextProvider';
import { IMonitorCategoryItem, ISingleMonitorHistoryItem } from '@/ts';

import styles from './styles.module.css';

type TProps = {
	data: any;
	columns: any;
	onTableChange: any;
	isLoading?: boolean;
	isFetching?: boolean;
	pagination: any;
	setPagination: any;
	onEditCreatorClick: any;
	monitor_id: number;
};

export default function SingleMonitorListHistoryTable({
	data,
	columns,
	onTableChange,
	isLoading,
	isFetching,
	pagination,
	setPagination,
	onEditCreatorClick,
	monitor_id,
}: TProps) {
	const navigate = useNavigate();
	const { openDrawer } = useContext(PageContext);
	// const { data: collectionStoreData } = useCollectionStore();
	const [currentId, setCurrentId] = useState<number | null>(null);

	const onViewListHistoryClick = (data: any) => {
		const { id, title } = data;

		navigate(`list-history/${id}`, {
			state: {
				monitor_id: monitor_id,
				category_id: id,
				category_title: title,
			},
			relative: 'path',
		});
	};

	return (
		<Table
			size="small"
			dataSource={data}
			columns={[
				...columns,
				{
					title: 'Actions',
					// ellipsis: true,
					width: 70,
					dataIndex: 'actions',
					key: 'actions',
					fixed: 'right',
					render: (_: any, record: ISingleMonitorHistoryItem) => {
						return (
							<Flex justify="center" align="center" style={{ gap: '4px' }}>
								<Tooltip title={'View insights'} mouseEnterDelay={1}>
									<Button
										size="middle"
										// size="small"
										onClick={() =>
											openDrawer('view-content-monitor-video-details', record)
										}
										style={{
											fontSize: '18px',
											padding: '6px',
											height: 'unset',
										}}
										className={styles.eyeHover}
										disabled={!record?.match_found}
									>
										<EyeOutlined />
									</Button>
								</Tooltip>
							</Flex>
						);
					},
				},
			]}
			style={{ width: '100%' }}
			// scroll={{ x: 500 }}
			rowClassName="editable-row"
			rowKey={'monitor_history_id'}
			onChange={onTableChange}
			loading={isLoading || isFetching}
			bordered
			pagination={{
				total: pagination?.total,
				showSizeChanger: true,
				current: pagination?.page,
				pageSizeOptions: [10, 25, 50],
				onChange: (page: number, pageSize: number) => {
					setPagination((cur: any) => ({ ...cur, page, limit: pageSize }));
				},
			}}
		/>
	);
}
